// components/GanttView.js
import { useCallback, useEffect, useRef, useState } from 'react';
import { gantt } from '@dhx/trial-gantt';
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import '../../assets/gant/dhtmlxgantt.css';
import AddEditTask from './new-task-popup';
import AddEditCategory from './new-category-popup';
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { useRouter } from 'src/routes/hooks';
import Iconify from '../iconify';
import Label from '../label';
import { USER_STATUS_OPTIONS } from 'src/_mock';
import { defaultConfigureGantt } from './components/gantt-configs/GanttConfigDefault';
import { configureZoom } from './components/GanttZoom';
import { configureLightbox } from './components/GanttLightbox';
import { allColumns, generateColumns } from './components/GanttColumns';
import { histogramConfigureGantt } from './components/gantt-configs/GanttConfigHistogram';
import { assignResourcesConfigureGantt } from './components/gantt-configs/GanttConfigAssignResources';
import { useData } from 'src/contexts/gantt-chart/gantt-context';
import { ConfirmDialog } from '../custom-dialog';
import { useBoolean } from 'src/hooks/use-boolean';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';

export default function GanttView({ gantt_resources }) {
  const { onDrop, onAddLink, removeLink } = useData();
  const { defaultVisibleColumn, handleColumnChange } = useData();
  const { enqueueSnackbar } = useSnackbar();

  const router = useRouter();
  const container = useRef();
  const [categoryModal, setCategoryModal] = useState(false);
  const [taskModal, setTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [resourceView, setResourceView] = useState('week');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [anchorColsEl, setAnchorColsEl] = useState(null);
  const [anchorColsEl2, setAnchorColsEl2] = useState(null);
  const openColsMenu = Boolean(anchorColsEl);
  const openColsMenu2 = Boolean(anchorColsEl2);
  const [currentTab, setCurrentTab] = useState('week');
  const [currentTab2, setCurrentTab2] = useState('Default View');
  const [currentTab3, setCurrentTab3] = useState('Title Wise');
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [selectedId, setSelectedId] = useState(false);
  const [linkLoading, setLinkLoading] = useState(false);
  const confirm = useBoolean();

  // const [defaultVisibleColumn, setdefaultVisibleColumn] = useState();

  useEffect(() => {
    gantt.plugins({ wbs: true, resource: true });
    // gantt.config.work_time = true;
    // gantt.config.correct_work_time = true;
    // gantt.templates.timeline_cell_class = function (task, date) {
    //   if (!gantt.isWorkTime({ date: date, task: task })) return 'weekend-highlight';
    //   return '';
    // };
    gantt.config.columns = generateColumns(defaultVisibleColumn, gantt);
    gantt.config.resource_render = 'tree';

    defaultConfigureGantt(
      gantt,
      () => generateColumns(defaultVisibleColumn, gantt),
      onDrop,
      onAddLink
    );
    // assignResourcesConfigureGantt(gantt, () => generateColumns(defaultVisibleColumn, gantt));
    gantt.attachEvent('onLinkDblClick', function (id, e) {
      // console.log(gantt_resources.links)
      // console.log(id);
      setSelectedId(id);
      confirm.onTrue();
    });
    configureZoom(gantt, resourceView);
    configureLightbox(
      gantt,
      setSelectedTask,
      setCategoryModal,
      router,
      setTaskModal,
      setSelectedDetails
    );
    gantt.init(container.current);
    if (gantt_resources) {
      gantt_resources.resources = gantt_resources?.resources_title;
      gantt.parse(gantt_resources);
    }
    // gantt.parse(gantt_resources.assign_resourse);

    return () => {
      gantt.clearAll(); // Clear data
    };
  }, [gantt_resources, resourceView, router]);

  useEffect(() => {
    gantt.config.columns = generateColumns(defaultVisibleColumn, gantt);
    gantt.render();
  }, [defaultVisibleColumn]);

  const handleZoomIn = () => {
    gantt.ext.zoom.zoomIn();
  };

  const handleZoomOut = () => {
    gantt.ext.zoom.zoomOut();
  };

  const handleSwitchToDayView = () => {
    setResourceView('day');
    gantt.ext.zoom.setLevel('day');
    gantt.render();
  };

  const handleSwitchToWeekView = () => {
    setResourceView('week');
    gantt.ext.zoom.setLevel('week');
    gantt.render();
  };

  const handleSwitchToMonthView = () => {
    setResourceView('month');
    gantt.ext.zoom.setLevel('month');
    gantt.render();
  };

  const handleCloseCategoryModal = () => {
    setCategoryModal(false);
    setSelectedTask(null);
  };

  const handleCloseTaskModal = () => {
    setTaskModal(false);
    setSelectedTask(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewSelect = (viewHandler) => {
    viewHandler();
    handleMenuClose();
  };

  const handleColsMenuClick = (event) => {
    setAnchorColsEl(event.currentTarget);
  };
  const handleColsMenuClick2 = (event) => {
    setAnchorColsEl2(event.currentTarget);
  };

  const handleColsMenuClose = () => {
    setAnchorColsEl(null);
  };
  const handleColsMenuClose2 = () => {
    setAnchorColsEl2(null);
  };

  const TABS = [
    {
      value: 'day',
      icon: <Iconify icon="solar:phone-bold" width={24} />,
      label: 'Day View',
    },
    {
      value: 'week',
      icon: <Iconify icon="solar:heart-bold" width={24} />,
      label: 'Week View',
    },
    {
      value: 'month',
      icon: <Iconify icon="solar:heart-bold" width={24} />,
      label: 'Month View',
    },
  ];

  const handleChangeTab = useCallback((event, newValue) => {
    if (newValue == 'day') {
      handleViewSelect(handleSwitchToDayView);
    } else if (newValue == 'week') {
      console.log('week');
      handleViewSelect(handleSwitchToWeekView);
    } else {
      handleViewSelect(handleSwitchToMonthView);
    }
    setCurrentTab(newValue);
  }, []);

  const handleChangeTab2 = useCallback((event, newValue) => {
    if (newValue == 'Default View') {
      defaultConfigureGantt(
        gantt,
        () => generateColumns(defaultVisibleColumn, gantt),
        onDrop,
        onAddLink
      );
    } else {
      histogramConfigureGantt(
        gantt,
        () => generateColumns(defaultVisibleColumn, gantt),
        onDrop,
        onAddLink
      );
    }
    gantt.resetLayout();
    setCurrentTab2(newValue);
  }, []);

  const handleChangeTab3 = useCallback(
    (event, newValue) => {
      if (!gantt_resources || !gantt) return;

      const updatedResources = { ...gantt_resources };
      gantt.resetLightbox();
      gantt.clearAll();
      gantt.resetLayout();

      switch (newValue) {
        case 'Activity Wise':
          updatedResources.resources = [...gantt_resources.resources_activity];
          // defaultConfigureGantt(gantt, () => generateColumns(defaultVisibleColumn, gantt));
          break;

        case 'Title Wise':
          updatedResources.resources = [...gantt_resources.resources_title];
          // defaultConfigureGantt(gantt, () => generateColumns(defaultVisibleColumn, gantt));
          break;

        default:
          break;
      }

      gantt.parse(updatedResources);
      setCurrentTab3(newValue);
    },
    [setCurrentTab3, gantt, defaultVisibleColumn, gantt_resources]
  );

  const onDeleteLink = async () => {
    setLinkLoading(true);
    const response = await removeLink(selectedId, gantt);
    if (response && response.metadata.success) {
      enqueueSnackbar({
        variant: 'success',
        message: response.metadata.message,
      });
      confirm.onFalse();
      gantt.deleteLink(selectedId);
    }
    setLinkLoading(false);
  };

  return (
    <>
      <Card
        sx={{
          width: '100%',
          margin: 'auto',
          mt: 4,
          // p: 2,
          borderRadius: '5px',
          // borderLeft:"10px solid #FFBDAD",
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 2 }}>
          <Typography variant="h4">Gantt Chart</Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography
              sx={{ cursor: 'pointer' }}
              onClick={handleColsMenuClick2}
              ml={1}
              fontSize={16}
            >
              Gantt View
            </Typography>
            <hr style={{ height: '20px' }} />

            <Menu
              anchorEl={anchorColsEl2}
              open={openColsMenu2}
              onClose={handleColsMenuClose2}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem
                onClick={() => {
                  handleViewSelect(handleSwitchToDayView);
                }}
                style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}
              >
                Day View
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleViewSelect(handleSwitchToWeekView);
                }}
                style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}
              >
                Week View
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleViewSelect(handleSwitchToMonthView);
                }}
                style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}
              >
                Month View
              </MenuItem>
            </Menu>
            <Box
              display="flex"
              alignItems="center"
              onClick={() => {
                window.location.href = '/gantt-chart/assign-hours';
              }}
            >
              <IconButton
                sx={{ position: 'relative', bottom: '2px' }}
                variant="outline"
                aria-label="Columns"
              >
                <Iconify icon="material-symbols:user-attributes" width="24" height="24" />
              </IconButton>
              <Typography sx={{ cursor: 'pointer' }} ml={1} fontSize={16}>
                Assign Resources
              </Typography>
            </Box>
            <hr style={{ height: '20px' }} />
            <Box display="flex" alignItems="center">
              <Box
                display="flex"
                alignItems="center"
                sx={{ cursor: 'pointer' }}
                onClick={handleColsMenuClick}
              >
                <IconButton variant="outline" aria-label="Columns">
                  <Iconify icon="material-symbols:filter-list-rounded" width="24" height="24" />
                </IconButton>
                <Typography ml={1} fontSize={16}>
                  Settings
                </Typography>
              </Box>

              <Menu
                anchorEl={anchorColsEl}
                open={openColsMenu}
                onClose={handleColsMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                {allColumns.map((col) => (
                  <MenuItem
                    key={col.name}
                    style={{ display: 'flex', justifyContent: 'space-between', padding: '0 10px' }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={defaultVisibleColumn[col.name]}
                          onChange={handleColumnChange}
                          name={col.name}
                        />
                      }
                      label={col.label}
                    />
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <hr style={{ height: '20px' }} />
            <Box>
              <IconButton variant="contained" onClick={handleZoomIn} aria-label="Zoom In">
                <Iconify icon="material-symbols:zoom-in" width="24" height="24" />
              </IconButton>

              <IconButton variant="contained" onClick={handleZoomOut} aria-label="Zoom Out">
                <Iconify icon="material-symbols:zoom-out" width="24" height="24" />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* <Stack m={0.5} spacing={2} sx={{ width: 1, pl: 2 }}>
          <Tabs value={currentTab} onChange={handleChangeTab}>
            {TABS.map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Stack> */}
        <Stack sx={{ position: 'relative' }}>
          <Box sx={{ position: 'absolute', zIndex: '1', top: '57.5%', left: '50%' }}>
            <Tabs value={currentTab2} onChange={handleChangeTab2}>
              {[
                { label: 'Default View', value: 'Default View' },
                { label: 'Histogram View', value: 'Histogram View' },
              ].map((tab) => (
                <Tab key={tab.value} value={tab.value} label={tab.label} />
              ))}
            </Tabs>
          </Box>

          <Box sx={{ position: 'absolute', zIndex: '1', top: '57.5%', left: '20px' }}>
            <Tabs value={currentTab3} onChange={handleChangeTab3}>
              {[
                { label: 'Title Wise', value: 'Title Wise' },
                { label: 'Activity Wise', value: 'Activity Wise' },
              ].map((tab) => (
                <Tab key={tab.value} value={tab.value} label={tab.label} />
              ))}
            </Tabs>
          </Box>
          <Box className="pink-gantt" ref={container} sx={{ width: '100%', height: '800px' }}></Box>
        </Stack>
      </Card>
      <AddEditCategory
        open={categoryModal}
        onClose={handleCloseCategoryModal}
        item={selectedTask}
      />
      <AddEditTask
        item={selectedDetails}
        selectedTask={selectedTask}
        open={taskModal}
        onClose={handleCloseTaskModal}
      />

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <LoadingButton
            loading={linkLoading}
            className="orange-button"
            variant="contained"
            color="error"
            onClick={onDeleteLink}
          >
            Delete
          </LoadingButton>
        }
      />
    </>
  );
}
